export default "__VITE_ASSET__BPPYqO6y__"